import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { isUsableConnectionString } from './utils/isUsableConnectionString';

const rawConnectionString =
  process.env.APPLICATIONINSIGHTS_CONNECTION_STRING ||
  process.env.SANITY_STUDIO_APPLICATIONINSIGHTS_CONNECTION_STRING ||
  undefined;

const connectionString = isUsableConnectionString(rawConnectionString) ? rawConnectionString : undefined;

const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: true,
      },
    })
  : null;
appInsights?.loadAppInsights();

export { appInsights };
